import { slotObjectToDataTestIds } from '@elliemae/ds-system';

export const DSTabsName = 'DSTabs';

export const TAB_TYPES = {
  NORMAL: 'normal' as const,
  NORMAL_SMALL: 'normal_small' as const,
  SUBTABS: 'subtabs' as const,
};

export const TAB_TYPES_VALUES_AS_ARRAY = Object.values(TAB_TYPES);

export const MOBILE_GRADIENT_WIDTH = 24;

export const DEFAULT_INDICATOR_STYLES = {
  left: 0,
  width: 0,
};

export const GRADIENT_OFFSETS_ACCORDING_TYPE = {
  NORMAL_SMALL: 14,
  NORMAL: 16,
  SUBTABS: 16,
  FIXED_TABS_HEADERS: 0,
};

export const TABS_SLOTS = {
  ROOT: 'root',
  TABS_CONTAINER: 'container',
  TAB_BUTTON: 'tab-button',
  SUBTAB_BUTTON: 'subtab-button',
  TAB_PANEL: 'tab-panel',
  SUB_TAB_LIST: 'subtabs-list',
  TAB_LIST: 'tab-list',
  CAROUSEL_BUTTON_RIGHT: 'chevron-right',
  CAROUSEL_BUTTON_LEFT: 'chevron-left',
  TABS_SWIPE_CARD: 'tabs-swipe-card',
} as const;

export const TABS_DATA_TESTID = {
  ...(slotObjectToDataTestIds(DSTabsName, TABS_SLOTS) as Record<keyof typeof TABS_SLOTS, string>),
  SUB_TAB_LIST: 'subtabs-list',
  TAB_LIST: 'tab-list',
  CAROUSEL_BUTTON_RIGHT: 'chevron-right',
  CAROUSEL_BUTTON_LEFT: 'chevron-left',
  CAROUSEL: {
    BUTTON_RIGHT: 'chevron-right',
    BUTTON_LEFT: 'chevron-left',
  },
};
